import { createSlice } from "@reduxjs/toolkit";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "groupParticipants": {}
}
 
const groupsMemberParticipantsList = createSlice({
    name:'appOnlineStatus',
    initialState,
    reducers:{
        addGroupsMemberParticipantsList: (_state,payload)=>{
            let data = payload.payload;
            let groupId = data?.groupId;
            let participantsList = data?.participantsList;
            let currentParticipantsList = StateToObj(_state)?.groupParticipants;
            currentParticipantsList[groupId] = participantsList;
            return {
                "groupParticipants": currentParticipantsList
            };
        }
    }
});

export default groupsMemberParticipantsList.reducer
export const addGroupsMemberParticipantsList = groupsMemberParticipantsList.actions.addGroupsMemberParticipantsList